// extracted by mini-css-extract-plugin
export default {"middle":"Middle_middle__lTjeO","space":"Middle_space__9ePv2","pinkBtn":"Middle_pinkBtn__DytMB"};